var messages = {
  moveAll: 'Move all',
  item: ' item',
  items: ' items'
};
export default messages;